import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { projectPage, deleteproject, dictList, projectList, getProjectNameListById as _getProjectNameListById, updateStatus } from '@/api/deviceOverview/file';
import { getLazyTree as _getLazyTree } from '@/api/base/region';
import { mapGetters } from 'vuex';
import FileModel from "./filemodel";
import Fileinfo from "./fileInfo";
export default {
  name: 'fileManage',
  components: {
    FileModel: FileModel,
    Fileinfo: Fileinfo
  },
  data: function data() {
    return {
      hisVisible: false,
      isinfo: true,
      currentPage: 1,
      totals: 0,
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 10
      },
      column: [{
        prop: 'address',
        label: this.$t('manipulation.installAddress')
      }, {
        prop: 'deviceCount',
        label: this.$t('manipulation.insNum')
      }, {
        prop: 'organization',
        label: this.$t('realdetile.contUnit')
      }, {
        prop: 'installDate',
        label: this.$t('fileManage.timeSetting')
      }, {
        prop: 'status1',
        label: this.$t('realdetile.projectStatus')
      }],
      DialogVisible: false,
      dialogType: this.$t('userManage.newAdd'),
      tableData: [],
      deviceNoInput: '',
      sawModelInput: '',
      typeList: [],
      typeList1: [],
      deviceStatus: '',
      projectName: '',
      address: '',
      elevatorBrand: '',
      devNumber: '',
      page: {
        current: 1,
        size: 10
      },
      column1: [{
        prop: 'index',
        label: this.$t('realdetile.serNum')
      }, {
        prop: 'projectName',
        label: this.$t('manipulation.devName')
      }, {
        prop: 'installAddress',
        label: this.$t('manipulation.installAddress')
      }, {
        prop: 'createUserName',
        label: this.$t('fileManage.chaAccount')
      }, {
        prop: 'createTime',
        label: this.$t('fileManage.updateTime')
      }],
      tableData1: [],
      cityList: [],
      province: [],
      props: {
        label: 'title',
        value: 'title'
      }
    };
  },
  computed: _objectSpread({}, mapGetters(['permission'])),
  created: function created() {
    this.getLazyTree();
    this.getdictList();
    console.log(this.$route.query.id);
  },
  mounted: function mounted() {},
  methods: {
    // 获取省市
    getLazyTree: function getLazyTree() {
      var _this = this;

      _getLazyTree().then(function (res) {
        if (res.data.code == 200) {
          _this.cityList = res.data.data;
        }
      });
    },
    getProjectNameListById: function getProjectNameListById(info) {
      var _this2 = this;

      _getProjectNameListById({
        id: info.id
      }).then(function (res) {
        if (res.data.code === 200) {
          res.data.data.map(function (item, index) {
            item.index = index + 1;
          });
          _this2.tableData1 = res.data.data;
        }
      });
    },
    hisinfo: function hisinfo(info) {
      this.getProjectNameListById(info);
      this.hisVisible = true;
    },
    getdictList: function getdictList() {
      var _this3 = this;

      projectList().then(function (res) {
        if (res.data.code === 200) {
          _this3.typeList = res.data.data;

          if (_this3.$route.query.id) {
            _this3.projectName = _this3.$route.query.id;
          }

          _this3.getprojectPage();
        }
      }); // 电梯

      dictList({
        code: "elevator_brand"
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.typeList1 = res.data.data[0].children;
        }
      });
    },
    result: function result() {
      this.projectName = '';
      this.address = '';
      this.elevatorBrand = '';
      this.devNumber = '';
      this.province = [];
      this.page.current = 1;
      this.getprojectPage();
    },
    getprojectPage: function getprojectPage() {
      var _this4 = this;

      var obj = _objectSpread({
        projectName: this.projectName,
        address: this.address,
        city: this.province[1],
        elevatorBrand: this.elevatorBrand,
        devNumber: this.devNumber,
        type: 'projectDetail'
      }, this.page);

      projectPage(obj).then(function (res) {
        if (res.data.code === 200) {
          res.data.data.records.map(function (item, index) {
            item.index = index + 1;
            item.status == 0 ? item.status1 = _this4.$t('fileManage.debug') : item.status == 1 ? item.status1 = _this4.$t('fileManage.set') : '';
          });
          _this4.tableData = res.data.data.records;
          _this4.page.current = res.data.data.current;
          _this4.totals = res.data.data.total;
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.current = e;
      this.getprojectPage();
    },
    //详情
    viewHandle: function viewHandle(info) {
      var _this5 = this;

      this.isinfo = false;
      setTimeout(function () {
        _this5.$refs.fileinfo1.getprojectDeviceList(info);
      }, 0);
    },
    goblack: function goblack() {
      this.isinfo = true;
    },
    addHandle: function addHandle() {
      this.dialogType = this.$t('userManage.newAdd');
      this.DialogVisible = true;
      this.$refs.filemodel.mapselectpoint();
    },
    editHandle: function editHandle(info) {
      this.dialogType = this.$t('roleManage.revise');
      this.DialogVisible = true;
      this.$refs.filemodel.mapselectpoint();
      this.$refs.filemodel.getinfo(info);
    },
    deleteHandle: function deleteHandle(info) {
      var _this6 = this;

      this.$confirm(this.$t('fileManage.infoback'), this.$t('export default.tip'), {
        confirmButtonText: this.$t('manipulation.sure'),
        cancelButtonText: this.$t('manipulation.cancel'),
        type: 'warning'
      }).then(function () {
        deleteproject({
          ids: info.id
        }).then(function (res) {
          if (res.data.code === 200) {
            _this6.$message.success(res.data.msg);

            _this6.getprojectPage();
          }
        });
      }).catch(function () {});
    },
    closefile: function closefile(num) {
      this.DialogVisible = false;

      if (num) {
        this.getprojectPage();
      }
    },
    editchange: function editchange(val) {
      var _this7 = this;

      var obj = {
        id: val.id,
        status: '1'
      };
      updateStatus(obj).then(function (res) {
        if (res.data.code === 200) {
          _this7.$message.success(res.data.msg);

          _this7.getprojectPage();
        }
      });
    }
  }
};